<template>
  <v-select
    solo
    color="grey"
    :items="items"
    class="select"
    item-value="id"
    v-model="active"
    item-text="name"
    label="Tipo de carga"
    :class="{'words': words}"
    no-data-text="No se encontraron cargas"
    @input="emitChange">
  </v-select>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    filters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      active: 0,
    };
  },
  computed: {
    words() {
      const words = this.items.find(x => x.id === Number(this.filters.company_load)) || {};
      return (words.name || '').length >= 15;
    },
    ...mapGetters([
      'companyLoad',
    ]),
    items() {
      return this.companyLoad;
    },
  },
  methods: {
    emitChange(val) {
      this.filters.company_load = val;
      this.$emit('search');
    },
  },
  watch: {
    'filters.company_load': {
      handler(val) {
        this.active = Number(val);
      },
    },
    companyLoad(val) {
      if (!this.filters.company_load && val.length > 0) {
        let check = this.companyLoad.find(x => x.check > 0);
        if (!check) {
          check = this.companyLoad.find(x => x.priority === 1);
        }
        this.filters.company_load = (check || {}).id || 0;
      }
    },
  },
};
</script>
<style scoped>
.select {
  text-align: left !important;
  white-space: nowrap;
}
.words >>> .input-group__selections__comma{
  font-size: 12px!important;
}
</style>


// WEBPACK FOOTER //
// src/components/global/CompanyLoadFilter.vue